import { render, staticRenderFns } from "./CarouselActionButtons.vue?vue&type=template&id=83129882&"
import script from "./CarouselActionButtons.vue?vue&type=script&lang=js&"
export * from "./CarouselActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./CarouselActionButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
